<app-page-header [title]="'Car Classes'" [subtitle]="'Manage car classes for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="car_class_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="car_class_search">Search car class</label>
        </p-ifta-label>
        <p-button label="Add Car Class" icon="pi pi-plus" (click)="this.openCreateCarClassDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.carClasses"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Label</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-carClass>
                <tr>
                    <td>{{ carClass.name }}</td>
                    <td>{{ carClass.label }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View car class"
                                      tooltipPosition="left"
                                      routerLink="/car-classes/car-class/{{carClass.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit car class"
                                      tooltipPosition="left"
                                      (click)="this.editCarClass(carClass)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete car class"
                                      tooltipPosition="left"
                                      (click)="this.deleteCarClass(carClass)"
                                      severity="danger"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="flex gap-2 mb-6">
    <p-button label="Export all Car Classes" icon="pi pi-download" (click)="this.exportCarClasses()"
              severity="secondary"></p-button>
</div>

<!-- Create Car Class Dialog -->
<app-create-car-class-dialog
        [(visible)]="this.displayCreateCarClassDialog"
        (carClassCreated)="this.reloadCarClasses()"
></app-create-car-class-dialog>

<!-- Update Car Class Dialog -->
<app-update-car-class-dialog
        [(visible)]="this.displayUpdateCarClassDialog"
        [carClass]="this.selectedCarClass"
        (carClassUpdated)="this.reloadCarClasses()"
></app-update-car-class-dialog>
